export const GENRES = [
  { id: 1, label: '발라드' },
  { id: 2, label: '힙합' },
  { id: 3, label: '알앤비' },
  { id: 4, label: '포크' },
  { id: 5, label: '댄스' },
  { id: 6, label: '재즈' },
  { id: 7, label: '키즈' },
  { id: 8, label: '클래식' },
  { id: 9, label: '뉴에이지' },
  { id: 10, label: '록' },
  { id: 11, label: '일렉트로닉' },
  { id: 12, label: '컴필레이션' },
  { id: 13, label: 'CCM' },
  { id: 14, label: 'OST' },
  { id: 15, label: '크로스오버' },
  { id: 16, label: '국악' },
];

export const GENRE_MAP = Object.fromEntries(GENRES.map((g) => [g.id, g.label]));
